<div class="centered">
  <div class="xml-sync" (click)="syncXML()">
    @if (syncingXML) {
<div><span></span></div>
}
    <i class="fa" [ngClass]="{ 'fa-check': isSynced, 'fa-refresh': !isSynced, 'fa-spinner fa-spin': syncingXML }"></i>
  </div>
  @if (!syncingXML) {
<h2>
    The XMLs are {{ isSynced ? 'in Sync with SLT.' : 'Not in Sync with the SLT. Please click above to Sync the XML.' }}
  </h2>
}
</div>
